import axios from "axios";
import Config from "../../../config/index";
import {
  GET_NOTCH_IMPACT_TEST_REQUEST,
  GET_NOTCH_IMPACT_TEST_SUCCESS,
  GET_NOTCH_IMPACT_TEST_FAILURE,
  DELETE_NOTCH_IMPACT_TEST_REQUEST,
  DELETE_NOTCH_IMPACT_TEST_SUCCESS,
  DELETE_NOTCH_IMPACT_TEST_FAILURE,
  CREATE_NOTCH_IMPACT_TEST_REQUEST,
  CREATE_NOTCH_IMPACT_TEST_SUCCESS,
  CREATE_NOTCH_IMPACT_TEST_FAILURE,
  EDIT_NOTCH_IMPACT_TEST_REQUEST,
  EDIT_NOTCH_IMPACT_TEST_SUCCESS,
  EDIT_NOTCH_IMPACT_TEST_FAILURE,
  UPLOADCSV_NOTCH_IMPACT_REQUEST,
  UPLOADCSV_NOTCH_IMPACT_SUCCESS,
  UPLOADCSV_NOTCH_IMPACT_FAILURE,
} from "./notchImpactTestTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getNotchImpactTestRequest = () => ({
  type: GET_NOTCH_IMPACT_TEST_REQUEST,
});
const getNotchImpactTestSuccess = (payload) => ({
  type: GET_NOTCH_IMPACT_TEST_SUCCESS,
  payload,
});
const getNotchImpactTestFailure = (error) => ({
  type: GET_NOTCH_IMPACT_TEST_FAILURE,
  payload: error,
});

const getNotchImpactTest = (dppId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getNotchImpactTestRequest());

    let url = dppId
      ? `${baseUrl}/dpp/notch_impact_test/get_dpp?dppId=${dppId}`
      : `${baseUrl}/dpp/notch_impact_test/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getNotchImpactTestSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getNotchImpactTestFailure(err.message));
      });
  };
};

// --- DELETE API ---
const deleteNotchImpactTestRequest = () => ({
  type: DELETE_NOTCH_IMPACT_TEST_REQUEST,
});
const deleteNotchImpactTestSuccess = (payload) => ({
  type: DELETE_NOTCH_IMPACT_TEST_SUCCESS,
  payload,
});
const deleteNotchImpactTestFailure = (error) => ({
  type: DELETE_NOTCH_IMPACT_TEST_FAILURE,
  payload: error,
});

const deleteNotchImpactTest = (notchImpactId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteNotchImpactTestRequest());
    let url = `${baseUrl}/dpp/notch_impact_test/delete?notchImpactId=${notchImpactId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteNotchImpactTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteNotchImpactTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
 
const createNotchImpactTestRequest = () => ({
  type: CREATE_NOTCH_IMPACT_TEST_REQUEST,
});
const createNotchImpactTestSuccess = (payload) => ({
  type: CREATE_NOTCH_IMPACT_TEST_SUCCESS,
  payload,
});
const createNotchImpactTestFailure = (error) => ({
  type: CREATE_NOTCH_IMPACT_TEST_FAILURE,
  payload: error,
});

const createNotchImpactTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createNotchImpactTestRequest());
    let url = `${baseUrl}/dpp/notch_impact_test/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createNotchImpactTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createNotchImpactTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
 
const editNotchImpactTestRequest = () => ({
  type: EDIT_NOTCH_IMPACT_TEST_REQUEST,
});
const editNotchImpactTestSuccess = (payload) => ({
  type: EDIT_NOTCH_IMPACT_TEST_SUCCESS,
  payload,
});
const editNotchImpactTestFailure = (error) => ({
  type: EDIT_NOTCH_IMPACT_TEST_FAILURE,
  payload: error,
});

const editNotchImpactTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editNotchImpactTestRequest());
    let url = `${baseUrl}/dpp/notch_impact_test/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editNotchImpactTestSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editNotchImpactTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForNotchImpactRequest = () => ({
  type: UPLOADCSV_NOTCH_IMPACT_REQUEST,
});

const uploadCsvForNotchImpactSuccess = (payload) => ({
  type: UPLOADCSV_NOTCH_IMPACT_SUCCESS,
  payload: payload,
});

const uploadCsvForNotchImpactFailure = (error) => ({
  type: UPLOADCSV_NOTCH_IMPACT_FAILURE,
  payload: error,
});

  const uploadCsvForNotchImpact = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForNotchImpactRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_tests/upload?testType=notchimpact`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForNotchImpactSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForNotchImpactFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  getNotchImpactTest,
  deleteNotchImpactTest,
  createNotchImpactTest,
  editNotchImpactTest,
  uploadCsvForNotchImpact,
};
